import React from 'react';
import logoGala from '../assets/common/LogoGala.png';
import './ErrorScreen.css';

// Les trois anneaux reprennent le camembert concentrique de l'accueil (cycle au
// centre, mental, sport à l'extérieur) : la page d'erreur reste reconnaissable comme
// un écran de l'app. Chaque anneau est un arc ouvert, décalé des autres.
const RINGS = [
  { r: 58, color: 'var(--phase-primary)',  arc: 0.72, rotate: -90 },
  { r: 74, color: 'var(--mental-primary)', arc: 0.6,  rotate: 30 },
  { r: 90, color: 'var(--sport-primary)',  arc: 0.66, rotate: 150 },
];

/**
 * Gabarit commun des pages d'erreur (404, plantage). Volontairement autonome : ni
 * `useAuth` ni `useNavigate`, pour pouvoir s'afficher depuis l'`ErrorBoundary`
 * même quand c'est un contexte qui a planté. Les actions arrivent en props.
 */
const ErrorScreen = ({ code, title, message, primaryAction, secondaryAction }) => (
  <main className="page page--centered error-screen">
    <img src={logoGala} alt="CycleGala" className="error-screen__logo" />

    <div className="error-screen__rings">
      <svg viewBox="0 0 200 200" aria-hidden="true" focusable="false">
        {RINGS.map(({ r, color, arc, rotate }) => {
          const circumference = 2 * Math.PI * r;
          return (
            <g key={r} transform={`rotate(${rotate} 100 100)`}>
              <circle cx="100" cy="100" r={r} className="error-screen__track" />
              <circle
                cx="100"
                cy="100"
                r={r}
                className="error-screen__arc"
                style={{ stroke: color }}
                strokeDasharray={`${circumference * arc} ${circumference}`}
              />
            </g>
          );
        })}
      </svg>
      <p className="error-screen__code">{code}</p>
    </div>

    <h1 className="error-screen__title">{title}</h1>
    <p className="error-screen__message">{message}</p>

    <div className="error-screen__actions">
      <button type="button" className="btn btn--primary" onClick={primaryAction.onClick}>
        {primaryAction.label}
      </button>
      {secondaryAction && (
        <button type="button" className="btn btn--outline" onClick={secondaryAction.onClick}>
          {secondaryAction.label}
        </button>
      )}
    </div>
  </main>
);

export default ErrorScreen;
